import Skeleton from "react-loading-skeleton";
import { TrackList as StyledTrackList, TrackSkeleton } from "./styled";
import { TrackCard } from "../TrackCard/TrackCard";
import { useDispatch } from "react-redux";
import { setInfoTrack } from "../../redux/Slice/trackInfoSlice";
import { openModal } from "../../redux/Slice/modalSlice";
import { modalState } from "../../utils/constants";
import { apiClient } from "../../api/api";

export const TrackList = ({ tracks, isLoading }) => {
  const dispatch = useDispatch();

  const changeCurrentTrack = async (trackData) => {
    try {
      const trackInfo = await apiClient
        .get("track", { params: { id: trackData.id } })
        .then((res) => res.data.data);

      dispatch(setInfoTrack(trackInfo));
      dispatch(openModal(modalState.TRACK_INFO));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Не удалось загрузить данные о треке", error);
    }
  };

  return (
    <StyledTrackList>
      {isLoading
        ? Array.from({ length: 3 }).map((_, index) => (
            <TrackSkeleton as={Skeleton} key={index} />
          ))
        : tracks?.map((track, index) => (
            <TrackCard
              key={track.id}
              track={track}
              index={index || 1}
              changeCurrentTrack={changeCurrentTrack}
            />
          ))}
    </StyledTrackList>
  );
};
